// Anima.js
import { config } from 'react-spring';

const handleScrollConfig = (activeSection, storyLength, deltaY) => {
  const currentIdx = activeSection;
  let nextIdx = 0;

  if (deltaY > 0) {
    nextIdx = (currentIdx + 1) % storyLength;
  } else {
    nextIdx = (currentIdx - 1 + storyLength) % storyLength;
  }
  return nextIdx;
};

const divStyleConfig = (showDescription) => ({
  height: showDescription ? '30%' : '80%',
  config: config.slow,
});

const textFadeConfig = (showDescription) => ({
  opacity: showDescription ? 1 : 0,
  config: config.slow,
});

const radioFadeConfig = (showDescription) => ({
  opacity: showDescription ? 1 : 0,
  config: config.slow,
});

const transitionsConfig = (activeSection) => ({
  from: { opacity: 0, transform: 'translate3d(0,100%,0)', zIndex: 1 },
  enter: { opacity: 1, transform: 'translate3d(0,0%,0)', zIndex: 2 },
  leave: { opacity: 0, transform: 'translate3d(0,-50%,0)', zIndex: 0 },
  config: config.slow,
});

const overlayAnimationConfig = (isOpen) => ({
  backgroundColor: isOpen ? 'rgba(50, 50, 50, 0.85)' : 'transparent',
  config: config.gentle,
});

const contentAnimationConfig = (isOpen) => ({
  transform: isOpen ? 'scale(1)' : 'scale(0.9)',
  config: config.gentle,
});

const trailConfig = (open) => ({
  config: { mass: 1, tension: 2000, friction: 200 },
  opacity: open ? 1 : 0,
  x: open ? 0 : 20,
  height: open ? 100 : 0,
  from: { opacity: 0, x: 20, height: 0 },
});

const toRoman = (num) => {
  let result = '';
  const roman = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 };

  for (let key in roman) {
    while (num >= roman[key]) {
      result += key;
      num -= roman[key];
    }
  }
  return result;
};

const formatModelName = (modelName) => {
  let formattedName = modelName.replace(/-/g, ' ');

  formattedName = formattedName.replace(/\d+/g, (match) => toRoman(parseInt(match)));

  return formattedName.toUpperCase();
};

const AnimaConfig = {
    handleScrollConfig,
    divStyleConfig,
    textFadeConfig,
    radioFadeConfig,
    transitionsConfig,
    overlayAnimationConfig,
    contentAnimationConfig,
    trailConfig,
    toRoman,
    formatModelName,
  };
  
  export default AnimaConfig;